<!-- eslint-disable max-len -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <!-- Add Cart Modal -->
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
          v-if="selectedArticle.highlightedImageUrl"
        />
        <img
          src="assets/images/no-image.jpg"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
          v-else
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">{{translations.goToShoppingCart}}</button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{translations.continueShopping}}
          </button>
        </div>
      </div>
    </modal>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id" />
      </div>
    </modal>
    <div class="container">
      <div class="row">
        <div class="col-lg-9 col-xl-5col-4">
          <nav class="toolbox mb-4 row search-toolbox">
            <div class="col-12 col-md-6 d-flex mobile-toolbox-controls">
              <div class="toolbox-item toolbox-sort">
                <div class="select-custom">
                  <select
                    name="orderby"
                    class="form-control"
                    v-model="sortField"
                    @change="handleSortChange"
                  >
                    <option :value="item.id" v-for="item in sortFields" :key="item.id">
                      {{ translations[item.label] }}
                    </option>
                  </select>
                </div>
                <!-- End .select-custom -->
              </div>
              <div class="toolbox-item toolbox-sort">
                <div class="select-custom">
                  <select
                    class="form-control"
                    name="results-per-page"
                    v-model="searchConfig.pageSize"
                    @change="changePageSize(searchConfig.pageSize)"
                  >
                    <option :value="page" v-for="page in pageSizeList" :key="page">
                      {{ page }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="toolbox-item toolbox-sort d-lg-none">
                <mobile-filters-toggle
                  :is-open="mobileFiltersOpen"
                  :label="translations.filters"
                  @click="toggleMobileFilters"
                />
              </div>
              <!-- End .toolbox-item -->
            </div>
            <!-- End .toolbox-left -->
            <div
              :class="
                [
                  'col-12 col-md-6',
                  'justify-content-between justify-content-md-end',
                  'align-items-center',
                  'mobile-toolbox-meta',
                  'd-flex',
                ].join(' ')
              "
            >
              <p class="toolbox-summary">{{ paginationResultsTitle }}</p>
              <div class="layout-modes d-none d-md-flex justify-content-end">
                <div
                  class="layout-btn btn-grid"
                  title="Grid"
                  :class="{ active: layout === 'grid' }"
                  @click="layout = 'grid'"
                >
                  <i class="fa fa-th"></i>
                </div>
                <div
                  class="layout-btn btn-list"
                  title="List"
                  :class="{ active: layout === 'list' }"
                  @click="layout = 'list'"
                >
                  <i class="fa fa-th-list"></i>
                </div>
                <div
                  class="layout-btn btn-bars"
                  title="Bars"
                  :class="{ active: layout === 'bars' }"
                  @click="layout = 'bars'"
                >
                  <i class="fas fa-bars"></i>
                </div>
              </div>
              <!-- End .layout-modes -->
            </div>
            <!-- End .toolbox-item -->
          </nav>
          <div class="row row-sm" v-if="articles && articles.length > 0 && layout === 'grid'">
            <div
              class="col-6 col-md-4 col-lg-3 mb-2"
              v-for="item in articles"
              :key="item.articleId"
            >
              <div class="product-default inner-quickview inner-icon bg-white h-100 mb-0">
                <figure>
                  <router-link
                    :to="{
                      name: 'Article',
                      params: { id: item.id, slug: slugify(item.title) }
                    }"
                  >
                    <Photo :src="`${baseUrl}${item.highlightedImageUrl}`"
                    v-if="item.highlightedImageUrl" />
                    <Photo src="assets/images/no-image.jpg" v-else />
                  </router-link>
                  <div
                    v-if="profile.discountDataVisible && getCurrentDiscount(item) > 0.1"
                    class="label-group"
                  >
                    <span class="product-label label-cut">
                      {{ getCurrentDiscount(item) | percentage }}%
                    </span>
                  </div>
                  <div v-if="!item.disableSelling || canPassRestrictions" class="btn-icon-group">
                    <button class="btn-icon btn-add-cart" @click="addToCart(item)">
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="icon-bag" v-else />
                    </button>
                  </div>
                  <button
                    class="btn btn-sm btn-quickview"
                    data-toggle="modal"
                    @click="getQuickArticle(item.id)"
                  >
                    {{ translations.quickPreview }}
                  </button>
                </figure>
                <div class="product-details">
                  <div class="category-wrap">
                    <div class="category-list">
                      <router-link
                        v-if="item.brandId"
                        class="product-category"
                        :to="{ name: 'Brand',
                         params: { id: item.brandId, title: item.brand.replace(/\s+/g, '-') } }"
                      >
                        {{ item.brand }}
                      </router-link>
                      <span v-else class="product-category">
                        {{ item.brand }}
                      </span>
                    </div>
                    <a
                      href="#"
                      @click.stop.prevent="toggleWishlistItem(item.articleId)"
                      class="btn-icon-wish"
                      :class="{ active: item.isOnWishlist }"
                    >
                      <i class="icon-heart" :class="{ 'icon-heart-1': item.isOnWishList }"></i>
                    </a>
                  </div>
                  <h2 class="product-title">
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: item.id, slug: slugify(item.title) }
                      }"
                    >
                      {{ item.title }}
                    </router-link>
                    <div
                    v-if="
                      item.oldPrice &&
                      item.oldPrice !== item.price &&
                      (!item.salePrice || (item.salePrice || 0) === 0)
                    "
                    class="label-group"
                  >
                    <span class="product-label label-cut">
                      {{ (100 * (1 - item.price / item.oldPrice)) | percentage }}%
                    </span>
                  </div>
                  <div v-if="item.salePrice || (item.salePrice || 0) > 0" class="label-group">
                    <span class="product-label label-cut">
                      {{ item.saleDiscountPercentage | percentage }}%
                    </span>
                  </div>
                  </h2>
                  <div class="ratings-container">
                    {{ translations.forms.labels.code }}: {{ item.code }}
                    <!-- End .product-ratings -->
                  </div>
                  <!-- End .product-container -->
                  <div class="price-box" v-if="(canViewPrices && !item.disableSelling) || canPassRestrictions">
                    <span class="product-price">{{
                      getCurrentPrice(item) | money3WithCurrency
                    }}</span>
                    <span class="old-price" v-if="getOldPrice(item) > 0">
                      {{ getOldPrice(item) | money3 }} KM
                    </span>
                  </div>
                  <!-- End .price-box -->
                  <button
                    v-if="
                      (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                      !canPassRestrictions
                    "
                    class="btn btn-primary btn-sm py-2 px-0 text-center btn-block"
                    @click="showOutOfStockModal(item)"
                  >
                  {{ translations.availableOnRequest }}
                  </button>
                </div>
                <!-- End .product-details -->
              </div>
            </div>
          </div>
          <div class="row row-sm" v-if="articles && articles.length === 0">
            <div class="col-12">
              <div class="alert alert-info">
                {{ translations.noResultsAccordingToTheGivenParameters }}.
              </div>
            </div>
          </div>

          <div class="row row-sm" v-if="layout === 'list' && articles && articles.length > 0">
            <div
              class="col-6 col-sm-12 product-default left-details product-list"
              v-for="item in articles"
              :key="item.id"
            >
              <figure>
                <router-link
                  :to="{
                    name: 'Article',
                    params: { id: item.id, slug: slugify(item.title) }
                  }"
                >
                  <img
                    :src="`${baseUrl}${item.highlightedImageUrl}`"
                    v-if="item.highlightedImageUrl"
                  />
                  <img src="assets/images/no-image.jpg" v-else />
                  <div class="label-group" style="position: absolute; top: 5px; left: 5px">
                    <span
                      v-if="
                        item.oldPrice &&
                        item.oldPrice !== item.price &&
                        (!item.salePrice || (item.salePrice || 0) === 0)
                      "
                      class="product-label label-cut"
                      >{{ (100 * (1 - item.price / item.oldPrice)) | percentage }}%</span
                    >
                    <span
                      v-if="item.salePrice || (item.salePrice || 0) > 0"
                      class="product-label label-cut"
                      >{{ item.saleDiscountPercentage | percentage }}% </span
                    >
                  </div>
                </router-link>
                <div
                  class="label-group"
                  v-if="getCurrentDiscount(item) > 0.1"
                  style="position: absolute; top: 5px; left: 5px"
                >
                  <span class="product-label label-cut">
                    {{ getCurrentDiscount(item) | percentage }}%
                  </span>
                </div>
              </figure>
              <div class="product-details product-details-list">
                <div class="category-list">
                  <a class="product-category">{{ item.brand }}</a>
                </div>
                <h2 class="product-title">
                  <router-link
                    :to="{
                      name: 'Article',
                      params: { id: item.id, slug: slugify(item.title) }
                    }"
                  >
                    {{ item.title }}
                  </router-link>
                </h2>
                <div class="ratings-container">
                  {{ translations.forms.labels.code }}: {{ item.code }}
                  <!-- End .product-ratings -->
                </div>
                <!-- End .product-container -->
                <p class="product-description" v-html="item.shortDescription">
                </p>
                <div class="price-box" v-if="(canViewPrices && !item.disableSelling) || canPassRestrictions">
                  <span class="product-price">{{ getCurrentPrice(item) | money3WithCurrency }}</span>
                  <span class="old-price" v-if="getOldPrice(item)">
                    {{ getOldPrice(item) | money3 }} KM
                  </span>
                </div>
                <!-- End .price-box -->
                <div class="product-action">
                  <div class="product-single-qty product-list-quantity" v-if="!item.disableSelling">
                    <div class="input-group">
                      <span
                        class="input-group-btn input-group-prepend"
                        @click="setQuantity(item, -1)"
                      >
                        <button class="btn btn-outline btn-down-icon" type="button" />
                      </span>
                      <input
                        class="horizontal-quantity form-control"
                        v-model.number="item.quantity"
                      />
                      <span
                        class="input-group-btn input-group-append"
                        @click="setQuantity(item, 1)"
                      >
                        <button class="btn btn-outline btn-up-icon" type="button" />
                      </span>
                    </div>
                  </div>
                  <button
                    v-if="!item.disableSelling || canPassRestrictions"
                    class="btn-icon btn-add-cart"
                    @click="addToCart(item)"
                  >
                    <i class="sicon-equalizer" v-if="item.hasAttributes" />
                    <i class="icon-bag" v-else />
                    {{ item.hasAttributes ? translations.chooseOptions : translations.addToCart }}
                  </button>
                  <button
                    v-if="
                      (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                      !canPassRestrictions
                    "
                    class="btn-icon btn-add-cart"
                    @click="showOutOfStockModal(item)"
                  >
                  {{ translations.availableOnRequest }}
                  </button>
                  <a
                    href="#"
                    @click.stop.prevent="toggleWishlistItem(item.id)"
                    class="btn-icon-wish"
                  >
                    <i class="icon-heart"></i>
                  </a>
                  <button class="btn-quickview" @click="getQuickArticle(item.id)">
                    <i class="fas fa-external-link-alt"></i>
                  </button>
                </div>
              </div>
              <!-- End .product-details -->
            </div>
          </div>

          <div
            class="table-product-list"
            v-if="layout === 'bars' && articles && articles.length > 0"
          >
            <table class="table text-left">
              <thead>
                <tr>
                  <th>{{ translations.manufacturer }}</th>
                  <th>{{ translations.forms.labels.code }}</th>
                  <th>{{ translations.productName }}</th>
                  <th>{{ translations.preview }}</th>
                  <th v-if="canViewPrices">VP Cijena</th>
                  <th>{{ translations.discount }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in articles" :key="item.id">
                  <td>
                    {{ item.brand }}
                  </td>
                  <td>
                    {{ item.code }}
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'Article', params: { id: item.id, slug: slugify(item.title) } }"
                    >
                      {{ item.title }}
                    </router-link>
                  </td>
                  <td>
                    <img
                      class="small-product-list-img"
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />
                    <img class="small-product-list-img" src="assets/images/no-image.jpg" v-else />
                  </td>
                  <td v-if="canViewPrices">
                    <span v-if="item.disableSelling">N/A</span>
                    <span v-else>{{ getCurrentPrice(item) | money3WithCurrency }}</span>
                  </td>
                  <td>{{ (item.salePrice > 0 && item.price > item.salePrice) ? item.saleDiscountPercentage.toFixed(2).replace('.', ',') + '%' : '-' }}</td>
                  <td class="order-actions justify-content-end">
                    <div class="product-single-qty" v-if="!item.disableSelling">
                      <div class="input-group bootstrap-touchspin">
                        <span
                          class="input-group-btn input-group-prepend"
                          @click="setQuantity(item, -1)"
                        >
                          <button class="btn btn-outline btn-down-icon" type="button" />
                        </span>
                        <input
                          class="horizontal-quantity form-control"
                          v-model.number="item.quantity"
                        />
                        <span
                          class="input-group-btn input-group-append"
                          @click="setQuantity(item, 1)"
                        >
                          <button class="btn btn-outline btn-up-icon" type="button" />
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="!item.disableSelling || canPassRestrictions"
                      class="btn-icon btn-add-cart"
                      @click="addToCart(item)"
                    >
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="fas fa-shopping-bag" v-else />
                    </div>
                    <div
                      v-if="
                        (item.disableSelling || (!item.stockAmount && !allowOrderingStockZero)) &&
                        !canPassRestrictions
                      "
                      class="btn-icon"
                      role="button"
                      @click="showOutOfStockModal(item)"
                    >
                      <button class="paction add-cart">{{ translations.availableOnRequest }}</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination :action="actionName" :pagination-props="paginationProps" />
        </div>
        <!-- End .col-lg-9 -->
        <mobile-filters-panel
          class="sidebar-shop col-lg-3 col-xl-5col-1 order-lg-first"
          :is-open="mobileFiltersOpen"
          :title="translations.filters"
          @close="closeMobileFilters"
        >
          <div class="sidebar-wrapper">
            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-on-stock"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-on-stock"
                >
                {{ translations.stock }}
                </a>
              </h3>
              <div class="collapse show" id="widget-on-stock">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="onStock"
                      :id="'checkbox-on-stock'"
                    />
                    <label class="custom-control-label" :for="'checkbox-on-stock'">
                      {{ translations.isInStock }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div class="widget">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-brands"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-brands"
                  >{{ translations.brands }}</a
                >
              </h3>
              <div
                class="collapse show"
                id="widget-brands"
                v-if="searchFilters && searchFilters.brands"
              >
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in searchFilters.brands"
                    :key="item.brandId"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.brandId"
                      v-model="brandIds"
                      :id="`checkbox-${item.brandId}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-${item.brandId}`">
                      {{ item.title }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <div v-if="searchFilters && searchFilters.attributes">
              <div class="widget" v-for="attribute in searchFilters.attributes" :key="attribute.id">
                <h3 class="widget-title">
                  <a
                    data-toggle="collapse"
                    :href="`#widget-body-attribute-${attribute.id}`"
                    role="button"
                    >{{ attribute.title }}</a
                  >
                </h3>
                <div class="collapse show" :id="`widget-body-attribute-${attribute.id}`">
                  <div class="widget-body">
                    <div v-if="attribute.attributeStyle !== 1">
                      <div
                        class="custom-control custom-checkbox category-checkbox"
                        v-for="item in attribute.attributeProperties"
                        :key="item.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="item.id"
                          v-model="attributeValuesIds"
                          :id="`checkbox-attribute-${item.id}`"
                        />
                        <label class="custom-control-label" :for="`checkbox-attribute-${item.id}`">
                          {{ item.title }}
                        </label>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="custom-control custom-checkbox category-checkbox"
                        v-for="item in attribute.attributeProperties"
                        :key="item.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="item.id"
                          v-model="attributeValuesIds"
                          :id="`checkbox-attribute-${item.id}`"
                        />
                        <label class="custom-control-label" :for="`checkbox-attribute-${item.id}`">
                        </label>
                        <label
                          :for="`checkbox-attribute-${item.id}`"
                          class="custom-color-label"
                          :style="{ backgroundColor: item.title }"
                        >
                        </label>
                      </div>
                    </div>
                  </div>
                  <!-- End .widget-body -->
                </div>
                <!-- End .collapse -->
              </div>
            </div>
            <!-- End .widget -->
            <div class="widget" v-if="searchFilters && searchFilters.maxPriceInThisCategory">
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-body-3"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-body-3"
                >
                  {{ translations.priceRange }}
                </a>
              </h3>
              <div class="collapse show" id="widget-body-3">
                <div>
                  <div class="filter-price-action">
                    <div class="filter-price-text">
                      {{ translations.vpc }}: {{ parseFloat(searchFilters.minPriceInThisCategory).toFixed(2) }} KM - {{ translations.vpc }}:
                      {{ parseFloat(searchFilters.maxPriceInThisCategory).toFixed(2) }} KM
                    </div>
                    <!-- End .filter-price-text -->
                  </div>
                  <div class="d-flex">
                    <input
                      ref="priceInput0"
                      type="number"
                      class="form-control form-control-sm price-range-min"
                      v-model="priceRange[0]"
                      @keyup="handlePriceChangeOnEnter"
                      @blur="roundPrice"
                    />
                    <input
                      ref="priceInput1"
                      type="number"
                      class="form-control form-control-sm price-range-max"
                      v-model="priceRange[1]"
                      @keyup="handlePriceChangeOnEnter"
                      @blur="roundPrice"
                    />
                  </div>
                  <div class="d-flex flex-row-reverse">
                    <button class="btn btn-primary btn-sm" @click="handlePriceChange">
                      {{ translations.apply }}</button>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>
            <!-- End .widget -->
            <div
              class="widget"
              v-if="searchFilters && searchFilters.tags && searchFilters.tags.length"
            >
              <h3 class="widget-title">
                <a
                  data-toggle="collapse"
                  href="#widget-tags"
                  role="button"
                  aria-expanded="true"
                  aria-controls="widget-tags"
                >
                {{ translations.tags }}
                </a>
              </h3>
              <div class="collapse show" id="widget-tags">
                <div class="widget-body">
                  <div
                    class="custom-control custom-checkbox category-checkbox"
                    v-for="item in searchFilters.tags"
                    :key="item.id"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="item.id"
                      v-model="tagIds"
                      :id="`checkbox-tag-${item.id}`"
                    />
                    <label class="custom-control-label" :for="`checkbox-tag-${item.id}`">
                      #{{ item.tagTitle }}
                    </label>
                  </div>
                </div>
                <!-- End .widget-body -->
              </div>
              <!-- End .collapse -->
            </div>

            <!-- End .widget -->
          </div>
          <!-- End .sidebar-wrapper -->
        </mobile-filters-panel>
        <!-- End .col-lg-3 -->
      </div>
      <!-- End .row -->
    </div>
    <!-- End .container -->
  </div>
</template>

<script>
import 'vue-range-component/dist/vue-range-slider.css';

import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';
import helpers from '@/services/helpers';

import Photo from '@/components/shared/Image.vue';
import MobileFiltersPanel from '@/components/shared/MobileFiltersPanel.vue';
import MobileFiltersToggle from '@/components/shared/MobileFiltersToggle.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';

import { translations, pager, mobileFilters } from '@/mixins';
import Pagination from '../components/shared/Pagination.vue';

export default {
  name: 'Search',
  mixins: [translations, pager, mobileFilters],
  components: {
    MobileFiltersPanel,
    MobileFiltersToggle,
    QuickPreview,
    Pagination,
    Photo,
    Modal,
  },
  data() {
    return {
      actionName: 'getQuickSearchArticles',
      layout: 'grid', // Can be list or grid
      layouts: ['grid', 'list'],
      priceRange: [],
      brandIds: [],
      attributeValuesIds: [],
      tagIds: [],
      selectedArticle: null,
      sortField: 1,
      onStock: false,
    };
  },
  computed: {
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    paginationProps() {
      return {
        quickSearch: this.$route.params.search.trim(),
        attributeValuesIds: this.attributeValuesIds,
        brandIds: this.brandIds,
        pageSize: this.searchConfig.pageSize,
        tagIds: this.tagIds,
        minPrice: parseFloat(this.priceRange[0], 10),
        maxPrice: parseFloat(this.priceRange[1], 10),
        onStock: this.onStock === false ? null : true,
      };
    },
    articles() {
      return (this.$store.getters.getSearchViewArticles || {}).articles || [];
    },
    baseUrl() {
      return config.baseUrl;
    },
    searchFilters() {
      return this.$store.getters.getSearchFilters;
    },
    category() {
      return this.$store.getters.getCategoryById(this.$route.params.id);
    },
    prices() {
      return [
        this.searchFilters?.minPriceInThisCategory.toFixed(2),
        this.searchFilters?.maxPriceInThisCategory.toFixed(2),
      ];
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    tags() {
      return this.$store.getters.getMostPopularTags;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  methods: {
    slugify,
    loadFiltersFromQuery() {
      const q = this.$route.query;

      this.brandIds = q.brandIds ? q.brandIds.split(',').map(Number) : [];
      this.attributeValuesIds = q.attributeValuesIds ? q.attributeValuesIds.split(',').map(Number) : [];
      this.tagIds = q.tagIds ? q.tagIds.split(',').map(Number) : [];

      this.sortField = q.sortField ? Number(q.sortField) : 1;

      this.onStock = q.onStock === 'true' || q.onStock === '1';

      if (q.priceRange) {
        const [min, max] = q.priceRange.split('-').map(Number);
        this.priceRange = [min, max];
      }
    },
    getCurrentPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;

      if (salePrice > 0 && salePrice < price) {
        return salePrice;
      }
      return price;
    },
    getCurrentDiscount(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      if (salePrice > 0 && salePrice < price) {
        return item.saleDiscountPercentage;
      }
      if (matchedPP) {
        return (100 * (1 - item.price / item.baseArticlePrice) * -1) || 0;
      }
      return 0;
    },
    handlePriceChangeOnEnter(event) {
      if (event.key === 'Enter') {
        if (parseFloat(this.priceRange[0], 10) > parseFloat(this.priceRange[1], 10)) {
          this.priceRange[0] = this.searchFilters.minPriceInThisCategory;
        }
        this.$refs.priceInput0.blur();
        this.$refs.priceInput1.blur();
        this.paginationProps.minPrice = parseFloat(this.priceRange[0], 10);
        this.paginationProps.maxPrice = parseFloat(this.priceRange[1], 10);
        this.getArticles();
      }
    },
    roundPrice() {
      this.priceRange[0] = parseFloat(this.priceRange[0]).toFixed(2);
      this.priceRange[1] = parseFloat(this.priceRange[1]).toFixed(2);
    },
    getOldPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;

      if (salePrice > 0 && salePrice < price) {
        return (item.baseArticlePrice === 0 || item.baseArticlePrice === null)
          ? item.price : item.baseArticlePrice;
      }
      if (matchedPP) {
        return item.baseArticlePrice;
      }
      return 0;
    },
    showOutOfStockModal(item) {
      this.$store.dispatch('showOutOfStockModal', { articleId: item.id });
    },
    setQuantity(item, num) {
      if (item.quantity === 1 && num === -1) return;
      // eslint-disable-next-line no-param-reassign
      item.quantity += num;
    },
    getArticles() {
      this.$store.dispatch('getQuickSearchArticles', this.paginationProps);
    },
    getFilters() {
      const quickSearch = this.$route.params.search;
      this.$store.dispatch('getQuickSearchFilters', {
        sortBy: 'title',
        isSortAscending: false,
        quickSearch,
        attributeValuesIds: [],
        brandIds: [],
        tagIds: [],
      });
    },
    handlePriceChange() {
      if (parseFloat(this.priceRange[0], 10) > parseFloat(this.priceRange[1], 10)) {
        this.priceRange[0] = this.searchFilters.minPriceInThisCategory;
      }
      this.paginationProps.minPrice = parseFloat(this.priceRange[0], 10);
      this.paginationProps.maxPrice = parseFloat(this.priceRange[1], 10);

      const priceRangeStr = `${this.paginationProps.minPrice}-${this.paginationProps.maxPrice}`;
      this.$router.replace({
        query: {
          ...this.$route.query,
          priceRange: priceRangeStr,
        },
      });
      this.getArticles();
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.getArticles();
        this.$store.dispatch('getWishList');
      });
    },
    addToCart(item) {
      if (item.hasAttributes || (!item.stockAmount && !this.allowOrderingStockZero)) {
        this.$router.push({ name: 'Article', params: { id: item.id, slug: slugify(item.title) } });
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.id,
          quantity: item.minOrderQuantity || 1,
        })
        .then(() => {
          this.$toast.info(helpers.getAddToCartToastMessage(item));
          this.$store.dispatch('getShoppingCart');
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info, { timeout: 4000 });
          this.$store.dispatch('getShoppingCart');
          $('#addCartModal').modal('hide');
        });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    handleSortChange() {
      const field = this.sortFields.find((i) => i.id === this.sortField);
      this.handleSort(field);
    },
    handleScroll() {
      localStorage.setItem('searchScrollPosition', window.scrollY);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    const scrollPosition = localStorage.getItem('searchScrollPosition');
    if (scrollPosition) {
      window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: 'smooth' });
    }
    this.getArticles();
    this.getFilters();
    this.roundPrice();
  },
  created() {
    this.loadFiltersFromQuery();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    brandIds() {
      if (this.brandIds.length === 0) {
        const { brandIds, ...rest } = this.$route.query;

        this.$router.replace({
          query: rest,
        });

        this.getArticles();
        return;
      }

      this.$router.replace({
        query: {
          ...this.$route.query,
          brandIds: this.brandIds.join(','),
        },
      });
      this.getArticles();
    },
    attributeValuesIds() {
      if (this.attributeValuesIds.length === 0) {
        const { attributeValuesIds, ...rest } = this.$route.query;

        this.$router.replace({
          query: rest,
        });

        this.getArticles();
        return;
      }

      this.$router.replace({
        query: {
          ...this.$route.query,
          attributeValuesIds: this.attributeValuesIds.join(','),
        },
      });
      this.getArticles();
    },
    prices() {
      this.priceRange = this.prices;
    },
    tagIds() {
      if (this.tagIds.length === 0) {
        const { tagIds, ...rest } = this.$route.query;

        this.$router.replace({
          query: rest,
        });

        this.getArticles();
        return;
      }

      this.$router.replace({
        query: {
          ...this.$route.query,
          tagIds: this.tagIds.join(','),
        },
      });
      this.getArticles();
    },
    onStock() {
      this.paginationProps.onStock = this.onStock === false ? null : true;
      const { onStock, ...rest } = this.$route.query;
      if (this.onStock === false) {
        this.$router.replace({ query: rest });
      } else {
        this.$router.replace({
          query: {
            ...this.$route.query,
            onStock: 'true',
          },
        });
      }
      this.getArticles();
    },
  },
};
</script>

<style lang="scss" scoped>
.product-default .product-title {
  display: block;
  width: 100%;
}

.product-list .product-details {
  width: calc(100% - 270px);
}

.category-checkbox {
  margin-top: 0;
  margin-bottom: 1rem;
}

.custom-color-label {
  width: 20px;
  height: 20px;
  background: black;
}

.custom-color-label {
  width: 6rem;
  height: 2rem;
}

.layout-btn {
  cursor: pointer;
}

.toolbox-summary {
  color: #5f6b76;
  font-size: 1.3rem;
  line-height: 1.45;
  margin: 0;
}

.order-actions {
  i {
    color: #1e84bc;
    font-size: 1.7rem;
    margin-right: 1.5rem;
  }
}

.order-actions {
  display: flex;
  border-top: none !important;
  margin-top: 10px;

  .product-single-qty {
    max-width: unset;
    max-height: unset;
  }

  .product-single-qty .bootstrap-touchspin.input-group {
    max-height: 30px;
  }

  .product-single-qty .bootstrap-touchspin .form-control {
    max-height: 30px;
  }

  i {
    color: #1e84bc;
    font-size: 1.7rem;
    margin-right: 1.5rem;
    padding-left: 5px;
  }

  .btn-icon.btn-add-cart {
    display: inline-block;
    padding-top: 5px;
    line-height: 1;
    height: 20px;
    margin-left: 10px;
  }
}

.btn-add-cart {
  cursor: pointer;
}

.product-list-quantity {
  height: 37px;
  margin-bottom: 5px;
  margin-right: 5px;

  .horizontal-quantity {
    height: 37px;
  }
}

.html-content a {
  color: #3598DB;
}

@media (max-width: 767px) {
  .search-toolbox {
    margin-bottom: 2rem !important;
  }

  .mobile-toolbox-meta {
    justify-content: flex-start !important;
    padding-top: 0;
  }

  .toolbox-summary {
    font-size: 1.25rem;
  }
}
</style>
